import { cn } from '../../lib/cn';

interface Props {
  size?: number;
  showText?: boolean;
  className?: string;
}

export function Logo({ size = 40, showText = true, className }: Props) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <img
        src="/logo.jpg"
        alt="HMT DAO"
        width={size}
        height={size}
        className="rounded-lg object-cover shadow-glow"
      />
      {showText && (
        <span className="font-extrabold tracking-[0.2em] text-lg">
          <span className="text-accent">HMT</span>
          <span className="text-fg">DAO</span>
        </span>
      )}
    </span>
  );
}
